import HealthAndSafetyOutlinedIcon from '@mui/icons-material/HealthAndSafetyOutlined';
import { Box, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router';
import { RoutesList } from '../config/routes-list';

/** Il perimetro "niente dati sanitari" va detto dove l'utente sceglie il file. */
export function HealthDataNotice() {
  const { t } = useTranslation();
  return (
    <Box
      role="note"
      data-testid="health-data-notice"
      sx={{ display: 'flex', gap: 1, alignItems: 'flex-start', color: 'text.secondary' }}
    >
      <HealthAndSafetyOutlinedIcon fontSize="small" sx={{ mt: 0.25 }} aria-hidden />
      <Typography variant="caption" sx={{ lineHeight: 1.5 }}>
        {t('documents.deadlines.healthDataNotice')}{' '}
        <Link
          component={RouterLink}
          to={RoutesList.PRIVACY}
          target="_blank"
          rel="noopener"
          underline="always"
        >
          {t('documents.deadlines.healthDataPrivacyLink')}
        </Link>
      </Typography>
    </Box>
  );
}
